export default __webpack_public_path__ + "assets/fonts/DMSans-Bold.woff2";